<button mat-raised-button class="image !h-full" (click)="openPatient()">
  Launch VixWin
</button>
